module.exports = __webpack_public_path__ + "static/img/huapai3.a251507.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/huapai3.png
// module id = by8E
// module chunks = 1